module.exports = __webpack_public_path__ + "media/base/customer-82edb36b.svg";